import axios from "axios";
import config from "../config";

// import { Clipboard } from "react-native";

// const isDev = false;

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  timeout: 1000000,
  // headers: { "Content-Type": "multipart/form-data" },
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // alert(config.data instanceof FormData);
    // Do something before request is sent
    // e.g., add authentication token
    config.headers["Content-Type"] =
      config.data instanceof FormData
        ? "multipart/form-data"
        : "application/json";

    // const token = localStorage.getItem("token");
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    // Clipboard.setString(JSON.stringify(config));
    // alert(JSON.stringify(config));
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // alert(error);
    // Handle response errors
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
